import { useQuery } from 'data-fetching-client';
import { GET_EMAIL_SUBSCRIPTIONS } from 'flow-doctor-lib/queries/EmailQueries';
const useEmailSubscription = ({
  portalId,
  subscriptionIds
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_EMAIL_SUBSCRIPTIONS, {
    variables: {
      portalId
    }
  });
  const dataToReturn = data ? data.emailSubscriptions.filter(subscription => subscriptionIds.includes(subscription.id)) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useEmailSubscription;